import React from 'react';
import { Facebook, Instagram, Phone } from 'lucide-react';
export function ContactSection() {
  return <section id="contact" className="py-16 md:py-24 bg-brand-teal relative" data-id="element-39">
      <div className="container mx-auto px-6 md:px-8" data-id="element-40">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20" data-id="element-41">
          {/* Left Content */}
          <div className="w-full lg:w-5/12 flex flex-col justify-center" data-id="element-42">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-6 leading-tight" data-id="element-43">
              Ready for a pool you can actually enjoy?
            </h2>

            <p className="text-lg text-white/80 mb-10 leading-relaxed" data-id="element-44">
              Call or text us at (480) 401-2244, email
              service@bonsaipoolcare.com, or fill out the form and we'll get
              back to you fast.
            </p>

            <div className="flex items-center gap-6" data-id="element-45">
              <a href="https://www.facebook.com/profile.php?id=61574761225288" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 transition-colors" aria-label="Facebook" data-id="element-46">
                <Facebook size={20} data-id="element-47" />
              </a>
              <a href="https://www.instagram.com/bonsaipoolcarellc/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 transition-colors" aria-label="Instagram" data-id="element-48">
                <Instagram size={20} data-id="element-49" />
              </a>
              <a href="https://www.tiktok.com/@bonsai.poolcare" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 transition-colors" aria-label="TikTok" data-id="element-50">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-51">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-52" />
                </svg>
              </a>
              <a href="tel:+14804012244" className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 transition-colors" aria-label="Call us" data-id="element-53">
                <Phone size={20} data-id="element-54" />
              </a>
            </div>
          </div>

          {/* Right Form */}
          <div className="w-full lg:w-7/12" data-id="element-55">
            <div className="bg-white rounded-2xl p-8 md:p-10 shadow-soft" data-id="element-56">
              <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-57">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-58">
                  <div className="space-y-2" data-id="element-59">
                    <label htmlFor="name" className="text-sm font-semibold text-brand-text" data-id="element-60">
                      Full Name
                    </label>
                    <input type="text" id="name" className="w-full bg-transparent border-0 border-b-2 border-gray-200 px-0 py-2 focus:ring-0 focus:border-brand-teal transition-colors min-h-[44px]" placeholder="John Doe" data-id="element-61" />
                  </div>
                  <div className="space-y-2" data-id="element-62">
                    <label htmlFor="phone" className="text-sm font-semibold text-brand-text" data-id="element-63">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" className="w-full bg-transparent border-0 border-b-2 border-gray-200 px-0 py-2 focus:ring-0 focus:border-brand-teal transition-colors min-h-[44px]" placeholder="(480) 555-0123" data-id="element-64" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-65">
                  <div className="space-y-2" data-id="element-66">
                    <label htmlFor="email" className="text-sm font-semibold text-brand-text" data-id="element-67">
                      Email
                    </label>
                    <input type="email" id="email" className="w-full bg-transparent border-0 border-b-2 border-gray-200 px-0 py-2 focus:ring-0 focus:border-brand-teal transition-colors min-h-[44px]" placeholder="john@example.com" data-id="element-68" />
                  </div>
                  <div className="space-y-2" data-id="element-69">
                    <label htmlFor="city" className="text-sm font-semibold text-brand-text" data-id="element-70">
                      City / Service Area
                    </label>
                    <input type="text" id="city" className="w-full bg-transparent border-0 border-b-2 border-gray-200 px-0 py-2 focus:ring-0 focus:border-brand-teal transition-colors min-h-[44px]" placeholder="Scottsdale" data-id="element-71" />
                  </div>
                </div>

                <div className="space-y-2" data-id="element-72">
                  <label htmlFor="message" className="text-sm font-semibold text-brand-text" data-id="element-73">
                    Message
                  </label>
                  <textarea id="message" rows={3} className="w-full bg-transparent border-0 border-b-2 border-gray-200 px-0 py-2 focus:ring-0 focus:border-brand-teal transition-colors resize-none" placeholder="How can we help with your pool?" data-id="element-74"></textarea>
                </div>

                <button type="submit" className="w-full bg-brand-amber text-white py-4 rounded-full font-semibold hover:bg-brand-amber/90 transition-colors min-h-[48px] mt-4 shadow-sm" data-id="element-75">
                  Send My Request
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>;
}